import React from 'react';
import { Shield } from 'lucide-react';
import AdminControls from './AdminControls';

const AdminPanel = ({ user }) => {
  // Early return if not admin
  if (!user || user.email !== 'rholt@pickstarai.com') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-900 via-slate-900 to-emerald-900 p-4">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h1 className="text-2xl">Unauthorized Access</h1>
          <p className="mt-4">You do not have permission to view this page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-900 via-slate-900 to-emerald-900 p-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-3 mb-8">
          <Shield className="w-8 h-8 text-emerald-400" />
          <h1 className="text-3xl font-bold text-white">Admin Panel</h1>
        </div>

        {/* Admin Sections */}
        <div className="space-y-8">
          {/* Subscription Management Section */}
          <section>
            <h2 className="text-xl text-white mb-4 border-b border-white/10 pb-2">
              Subscription Management
            </h2>
            <AdminControls />
          </section>

          {/* Add more admin sections here as needed */}
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;